import { render, staticRenderFns } from "./Breadcrumbs.vue?vue&type=template&id=d61eb35e&scoped=true&"
import script from "./Breadcrumbs.vue?vue&type=script&lang=js&"
export * from "./Breadcrumbs.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./Breadcrumbs.vue?vue&type=style&index=0&id=d61eb35e&lang=sass&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "d61eb35e",
  "1e9be215"
  
)

export default component.exports